import { Inject, Injectable } from '@angular/core';

import { Observable, map, share } from 'rxjs';

import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../base/services/betslip-messages-provider.service';
import { IPlaceBetButtonMessages } from '../../../betplacement/models';
import { PlaceButtonMessagesProviderService } from '../../../betplacement/services/place-button/place-button-messages-provider.service';

@Injectable()
export class TeaserBetPlaceButtonMessagesProviderService extends PlaceButtonMessagesProviderService {
    private overriddenMessages$: Observable<IPlaceBetButtonMessages>;

    constructor(@Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messagesProvider: IBetslipMessagesProviderService) {
        super(messagesProvider);

        const teaserBetMessages = messagesProvider.getMessages()!.teaserBet!.messages;

        const standardMessages$ = super.messages$;

        this.overriddenMessages$ = standardMessages$.pipe(
            map((standardMessages) => {
                return {
                    ...standardMessages,
                    placeBet: teaserBetMessages.PlaceTeaser,
                };
            }),
            share(),
        );
    }

    override get messages$(): Observable<IPlaceBetButtonMessages> {
        return this.overriddenMessages$;
    }
}
